import * as React from "react";

function SvgPlateWaitingToBeImaged(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" {...props}>
      <path
        d="M23.53 13h8.94c.652 0 1.177.511 1.177 1.146v1.97h6.58c1.536 0 2.773 1.204 2.773 2.701v15.23c0 1.086-.65 2.017-1.592 2.448a7.503 7.503 0 00-5.31-9.515 7.808 7.808 0 00-2.358-6.14A8.227 8.227 0 0028 18.523a8.227 8.227 0 00-5.74 2.317 7.808 7.808 0 00-2.378 5.593c0 2.098.856 4.11 2.378 5.593a8.195 8.195 0 004.49 2.222v.002c0 .877.15 1.718.427 2.5H15.773c-1.536 0-2.773-1.205-2.773-2.702V18.817c0-1.497 1.237-2.702 2.773-2.702h6.58v-1.969c0-.635.525-1.146 1.176-1.146z"
        fill="#fff"
      />
      <path
        d="M34.345 26.75h-.095a7.503 7.503 0 00-7.303 5.787 6.412 6.412 0 01-3.44-1.727 6.11 6.11 0 01-1.86-4.377 6.11 6.11 0 011.86-4.378A6.438 6.438 0 0128 20.242c1.685 0 3.3.652 4.492 1.813a6.111 6.111 0 011.853 4.696z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.25 43a8.75 8.75 0 100-17.5 8.75 8.75 0 000 17.5zm0-1.25a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
        fill="#fff"
      />
      <path
        d="M37.531 29.25H30.97a.469.469 0 00-.469.469v.312c0 .26.21.469.469.469 0 1.777.996 3.276 2.36 3.75-1.364.474-2.36 1.973-2.36 3.75a.469.469 0 00-.469.469v.312c0 .26.21.469.469.469h6.562c.26 0 .469-.21.469-.469v-.312a.469.469 0 00-.469-.469c0-1.777-.996-3.276-2.36-3.75 1.364-.474 2.36-1.973 2.36-3.75.26 0 .469-.21.469-.469v-.312a.469.469 0 00-.469-.469zm-1.466 7.5h-3.63c.333-.914 1.018-1.563 1.815-1.563.797 0 1.482.649 1.815 1.563zm0-5h-3.63a3.664 3.664 0 01-.216-1.25h4.062c0 .445-.078.87-.216 1.25z"
        fill="#fff"
      />
      <circle cx={28} cy={28} r={27} stroke="#fff" />
    </svg>
  );
}

export default SvgPlateWaitingToBeImaged;
